const NAMESPACE = 'shop/';

export default {
  GET_PAYMENT_INFORMATION: `${NAMESPACE}GET_PAYMENT_INFORMATION`,
  GET_PAYMENT_INFORMATION_REQUEST: `${NAMESPACE}GET_PAYMENT_INFORMATION_REQUEST`,
  GET_PAYMENT_INFORMATION_SUCCESS: `${NAMESPACE}GET_PAYMENT_INFORMATION_SUCCESS`,
  GET_PAYMENT_INFORMATION_FAILURE: `${NAMESPACE}GET_PAYMENT_INFORMATION_FAILURE`,
  SET_PAYMENT_SCREEN: `${NAMESPACE}SET_PAYMENT_SCREEN`,
};
